import { MicrosoftIcon } from '@common/components/brand/MicrosoftIcon';
import { Alert, Button } from '@ntconsult/aluma-react';
import { Info } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks';

/**
 * Ações de entrada (SPEC 1.4 / login). Entra ID é o ÚNICO método (1.1 BR-1):
 * sem formulário de e-mail/senha. O botão dispara o redirect; os estados de erro
 * (`auth_failed` genérico, `account_inactive` sem retry) vêm do callback do back.
 */
export function LoginForm() {
  const { t } = useTranslation('auth');
  const { login } = useAuth();
  const [params] = useSearchParams();
  const [redirecting, setRedirecting] = useState(false);
  const error = params.get('error');
  const inactive = error === 'account_inactive';

  return (
    <div className="flex flex-col gap-5">
      {error === 'auth_failed' && (
        <Alert variant="danger" title={t('errorAuthFailedTitle')}>
          {t('errorAuthFailedDescription')}
        </Alert>
      )}
      {inactive && (
        <Alert variant="warning" title={t('errorAccountInactiveTitle')}>
          {t('errorAccountInactiveDescription')}
        </Alert>
      )}

      {!inactive && (
        <Button
          type="button"
          variant="primary"
          fullWidth
          loading={redirecting}
          leftIcon={<MicrosoftIcon />}
          onClick={() => {
            setRedirecting(true);
            login();
          }}
        >
          {t('signInWithMicrosoft')}
        </Button>
      )}

      <p className="flex items-center gap-2 text-sm text-foreground-muted">
        <Info size={16} aria-hidden />
        {t('useCorporateAccount')}
      </p>
    </div>
  );
}
